//@ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import Label from 'components/grid/table/components/label';
import { Container } from 'components/grid/table/components/actions/components/action/style';
import { isFunction, noop } from 'lodash';
import { renderChildren } from 'utils/react';

class Action extends React.Component<any> {
  static propTypes = {
    onClick: PropTypes.func,
    render: PropTypes.func,
    label: PropTypes.string,
    icon: PropTypes.node,
    data: PropTypes.any,
    hide: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    show: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    type: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    align: PropTypes.string,
  };

  static defaultProps = {
    label: '',
    icon: null,
    render: undefined,
    onClick: noop,
    data: undefined,
    show: true,
    hide: false,
    type: '',
    children: undefined,
    align: undefined,
  };

  shouldHide = () => {
    let { hide, show } = this.props;

    if (hide) {
      hide = isFunction(hide) ? hide(this.props.data) : hide;
    }

    if (show) {
      show = isFunction(show) ? show(this.props.data) : show;
    }

    return hide || !show;
  };

  onClick = () => {
    const { onClick, data } = this.props;
    return onClick(data);
  };

  render() {
    const { render, label, icon, type, children, data, align } = this.props;

    if (this.shouldHide()) {
      return null;
    }

    if (render) {
      return render.call(this);
    }

    const content = children ? (
      renderChildren(children, data)
    ) : (
      <>
        {icon}
        <Label>{label}</Label>
      </>
    );

    return (
      <Container data-type={type} onClick={this.onClick} align={align}>
        {content}
      </Container>
    );
  }
}

export default Action;
